import styled from "styled-components";

export const StyledStepLine = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 16px 0px;

  .step-line {
    position: absolute;
    top: 20px;
    left: calc(16.666% + 12px);
    right: calc(16.666% + 12px);
    height: 1px;
    background: #d9d9d9;
    border-radius: 0;
  }
  .step-dot {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #999999;
    font-size: 13px;
    line-height: 20px;
    font-family: "Manrope-Medium", sans-serif;
    text-align: center;

    &--active {
      color: #1a1a1a;
      font-family: "Manrope-Bold", sans-serif;

      .step-dot-icon {
        border-color: #1a1a1a;
        background: radial-gradient(circle, #1a1a1a 0 3px, #ffffff 4px);
      }
    }
    &--completed {
      color: #4d4d4d;

      .step-dot-icon {
        color: #fff;
        border-color: #45c149;
        background: #45c149;
      }
    }
  }
  .step-dot-icon {
    width: 24px;
    height: 24px;
    border-radius: 999px;
    border: 1.5px solid #d9d9d9;
    background: #ffffff;
    overflow: hidden;
  }
`;
